import { useCallback } from 'react'
import { useSearchParams } from 'react-router'

/**
 * A list's search text, kept in the address bar as `?q=` so it is still
 * applied after opening a row and navigating back, and can be shared as a link.
 *
 * Updates replace the current history entry rather than pushing one, so Back
 * leaves the list instead of stepping through every search typed.
 */
export function useUrlSearch(param = 'q') {
  const [searchParams, setSearchParams] = useSearchParams()
  const search = searchParams.get(param) ?? ''

  const setSearch = useCallback(
    (value: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev)
          if (value) next.set(param, value)
          else next.delete(param)
          return next
        },
        { replace: true }
      )
    },
    [param, setSearchParams]
  )

  return [search, setSearch] as const
}
